/* eslint-disable array-callback-return */
import React, { useEffect, useMemo } from "react";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";
import { InnerHOC } from "../../Layout/LoggedInLayout/innerPage";
import HolidayItem from "./Item";
import { Row } from "reactstrap";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import { HolidayCalendarAtom, activeChildDetail } from "../../AtomStore/store";

import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import { fetchHolidayCalendarData } from "../../QueryFunctions/queryfunction";
import { StyledH3 } from "./styles";

const HolidayCalender = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [holidayCalendar, setHolidayCalendar] = useAtom(HolidayCalendarAtom);

  const [activeChild] = useAtom(activeChildDetail);

  const { isLoading } = useQueryWrapper(
    ["holidayCalendar", activeChild?.id],
    () => fetchHolidayCalendarData(activeChild),
    {
      onSuccess: (data) => {
        setHolidayCalendar(data);
      },
    }
  );

  useMemo(() => {
    console.log(
      `[Holiday Calendar] Fetching Holiday Calendar details for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  let monthList = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const colorSchemes = [
    {
      background: "#FFEBEE",
      text: "#C62828",
      shadow: "0px 4px 10px rgba(198, 40, 40, 0.3)",
    },
    {
      background: "#E3F2FD",
      text: "#1565C0",
      shadow: "0px 4px 10px rgba(21, 101, 192, 0.3)",
    },
    {
      background: "#E8F5E9",
      text: "#2E7D32",
      shadow: "0px 4px 10px rgba(46, 125, 50, 0.3)",
    },
  ];
  let holidayList = [];
  let currentMonth = new Date().getMonth();
  let holidayCalendarArray = Array.isArray(holidayCalendar)
    ? holidayCalendar
    : [];
  holidayList = holidayCalendarArray.filter(
    (data) =>
      monthList.findIndex((ele) => data.dateGroup === ele) >= currentMonth
  );

  let pastholidayList = holidayCalendarArray.filter(
    (data) =>
      monthList.findIndex((ele) => data.dateGroup === ele) < currentMonth
  );

  console.log("Log inisde holiday calendar: ", holidayCalendarArray);

  const holidayRenderList = Array.isArray(holidayList)
    ? [...holidayList, ...pastholidayList]
    : [];

  return (
    <InnerHOC heading="Holiday Calendar">
      {
        <React.Fragment>
          <Row>
            {holidayRenderList.map((monthWiseData, index) => {
              const colorScheme = colorSchemes[index % colorSchemes.length];
              return (
                <div key={index}>
                  <StyledH3>{monthWiseData.dateGroup}</StyledH3>
                  <Row>
                    <HolidayItem
                      key={monthWiseData.dateGroup}
                      items={monthWiseData.data}
                      colorScheme={colorScheme}
                      month={monthWiseData.dateGroup}
                    />
                  </Row>
                </div>
              );
            })}
          </Row>
        </React.Fragment>
      }
      {(!Array.isArray(holidayCalendar) ||
        holidayCalendar.length === 0 ||
        holidayCalendar === undefined) && (
        <ListEmptyComponent
          heading={isLoading ? "Loading..." : "No Data Found"}
        />
      )}
      {isLoading ? <SpinnerLoading /> : <></>}
    </InnerHOC>
  );
};

export default HolidayCalender;
